import { CaseService } from '@feature/cases/case.service';
import { AppointmentCaseModel } from '@feature/cases/case_appointment_model';
import { MessagingCaseModel } from '@feature/cases/case_messaging_model';
import { Injectable } from '@visiba/instantiation';
import { Presentation } from '@visiba/presentation';

export interface CasesCollection {
	appointmentCases: AppointmentCaseModel[];
	messagingCases: MessagingCaseModel[];
}

export interface PresentationModel {
	ongoingCases: CasesCollection | null;
	completedCases: CasesCollection | null;
}

@Injectable()
export class VisitsController {
	public readonly presentation = Presentation.create<PresentationModel>({
		ongoingCases: null,
		completedCases: null,
	});

	private casePollerDisposer: (() => void) | null = null;

	constructor(private readonly caseService: CaseService) {
		this.caseService.updateSync();

		this.casePollerDisposer = this.caseService.pollData(() => {
			this.parsePolledData();
		});
	}

	public clearEvents(): void {
		if (this.casePollerDisposer != null) {
			this.casePollerDisposer();
			this.casePollerDisposer = null;
		}
	}

	private parsePolledData(): void {
		const { completed, ongoing } = this.caseService.getGroupedCases();

		function sortByDateAscending(
			a: AppointmentCaseModel | MessagingCaseModel,
			b: AppointmentCaseModel | MessagingCaseModel,
		): -1 | 0 | 1 {
			const dataA = a.get();
			const dataB = b.get();

			if (dataA.date.isBefore(dataB.date)) return -1;
			if (dataA.date.isAfter(dataB.date)) return 1;

			return 0;
		}

		function sortByDateDescending(
			a: AppointmentCaseModel | MessagingCaseModel,
			b: AppointmentCaseModel | MessagingCaseModel,
		): -1 | 0 | 1 {
			const dataA = a.get();
			const dataB = b.get();

			if (dataA.date.isAfter(dataB.date)) return -1;
			if (dataA.date.isBefore(dataB.date)) return 1;

			return 0;
		}

		this.presentation.write({
			completedCases: {
				appointmentCases: completed.appointmentCases.sort(sortByDateDescending),
				messagingCases: completed.messagingCases.sort(sortByDateDescending),
			},
			ongoingCases: {
				appointmentCases: ongoing.appointmentCases.sort(sortByDateAscending),
				messagingCases: ongoing.messagingCases.sort(sortByDateDescending),
			},
		});
	}
}
